module.exports = __webpack_public_path__ + "img/ltkeaster-4x.c39c459.jpg";